import React, { FC } from "react";
import { CheckoutLineData } from "@containers/PayPerLead/interface";

import { Price } from "./Price";

export interface CheckoutRowTotalProps {
  item: CheckoutLineData;
  serverPrice?: number;
}

export const CheckoutRowTotal: FC<CheckoutRowTotalProps> = ({ item, serverPrice }) => {
  return (
    <>
      <div className="total">
        <div className="label">{item.label}</div>
        <div className="amount">
          <Price amount={serverPrice ?? item.price} />
        </div>
      </div>
    </>
  );
};
